import { get, post } from '@/api/fetch'

export function loginSupport(accessToken: string) {
  return get<boolean>(`/users/token/${accessToken}/checkSupport`).then(res => res.data)
}

export function getBillingStatus() {
  return get('/billing/status').then(res => res.data)
}

export function getDemoAuth() {
  return get('/demoAuthData').then(res => res.data)
}

export function recoverPassword(recoverId: string) {
  return get(`/users/recovery/${recoverId}`).then(res => {
    return res.data.email
  })
}

export function verificationToken(email: string) {
  return post(`/users/verification-token`, {
    email: email
  })
}

export function newPasswordCallback(data: { token: string; recoverId: string; password: string }) {
  return post(`/users/recovery/${data.recoverId}`, {
    token: data.token,
    password: data.password
  })
}
